import { createSelector } from "@reduxjs/toolkit"

export const getData = (state) => state.breadCrumbs || {}

export const getBreadCrumbs = createSelector(getData, ({ breadCrumbs }) => breadCrumbs || [])
